var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv2-2.jpg",
      "video": "/images/sub/visual/sv2-2.mp4"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-bold"
  }, [_vm._v("고객사")])])])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 세계적인 기업 및 단체들이 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 세일즈웍스와 함께합니다. ")])]), _c('div', {
    staticClass: "mb-50 mb-lg-100"
  }, [_c('h5', {
    staticClass: "bar-text mb-30 mb-lg-34"
  }, [_vm._v(" 국내외 기업 ")]), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "100"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-1.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-2.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-3.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-4.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-5.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-6.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-7.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-8.jpg"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "300"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-9.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-10.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-11.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-12.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-13.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-14.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-15.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-16.jpg"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "500"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-17.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-18.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-19.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-20.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-21.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-22.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-23.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner1-24.jpg"
    }
  })], 1)], 1)], 1), _c('v-divider', {
    staticClass: "border-lg-2"
  }), _c('div', {
    staticClass: "mt-50 mt-lg-100"
  }, [_c('h5', {
    staticClass: "bar-text mb-30 mb-lg-34"
  }, [_vm._v(" 비영리단체 ")]), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "100"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-1.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-2.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-4.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-5.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-6.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-7.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-8.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-9.jpg"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "300"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-10.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-11.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-12.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-13.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-14.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-15.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-16.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-17.jpg"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "500"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-18.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-19.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-20.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-21.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-22.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-23.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-24.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-25.jpg"
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "data-aos": "fade",
      "data-aos-offset": "400",
      "data-aos-delay": "700"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-26.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-27.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-28.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-29.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-30.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-31.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/business/client/partner2-32.jpg"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }